<template>
  <div>
    <DeleteModal modalId="modal-attachment-delete" @deleteToggle="deleteItem" />

    <!-- <b-modal
      :no-close-on-backdrop="true"
      id="modal-attachment-delete"
      title="Delete Attachment"
      ok-only
      ok-title="Delete"
      @ok="deleteItem"
    >
      <b-card-text>
        <h5>Are You Sure You Want to Remove This Attachment</h5>
        If you want to remove this Attachment, click the button below.
      </b-card-text>
    </b-modal> -->
    <b-card>
      <div>
        <div class="d-flex justify-content-between mt-4 mb-2">
          <h2>{{ $t("reception.Patient Attachments") }}</h2>

          <div>
            <b-form-group v-slot="{ ariaDescribedby }" class="d-flex">
              <b-form-radio-group
                v-model="selected"
                :options="options"
                class="mb-3"
                value-field="item"
                text-field="name"
                disabled-field="notEnabled"
                @change="attachmentChange"
              ></b-form-radio-group>
            </b-form-group>
          </div>
        </div>
        <template v-if="loading">
          <div>
            <div class="d-flex justify-content-center mb-1">
              <b-spinner label="Loading..." />
            </div>
          </div>
        </template>
        <div
          v-else
          class="overflow-auto pb-5 d-flex flex-wrap gap-8 justify-content-center mt-10"
        >
          <div
            class="align-items-center border col-3 border-dashed bg-gray-200 border-gray-300 rounded mx-1 my-1 px-1 py-1"
            v-for="(file, index) in data"
            :key="index"
          >
            <div class="d-flex justify-content-end mb-1">
              <!-- <feather-icon
                icon="TrashIcon"
                style="cursor: pointer"
                class="text-danger"
                @click="deleteDocs(file.id)"
              /> -->
              <b-button
                v-if="!isHistory"
                pill
                variant="outline-danger"
                size="sm"
                @click="deleteModel(file)"
                >{{ $t("common.delete") }}</b-button
              >
            </div>

            <div
              class="d-flex gap-1 justify-content-center"
              @click="openFileInNewTab(file.attachment_url)"
            >
              <b-img :src="file.attachment_url" style="width: 200px"></b-img>
            </div>

            <!--end::Info-->
          </div>
        </div>
        <div class="w-100 d-flex justify-content-center">
          <div>
            <b-form-file
              v-if="!isHistory"
              v-model="EditForm.attachment"
              :state="Boolean(EditForm.attachment)"
              :placeholder="$t('common.Drag your file here or click to upload')"
              drop-placeholder="Drop file here..."
              @change="handleFileUpload"
              class="dropzone d-flex justify-content-center"
            ></b-form-file>
            <div v-if="EditForm.attachment.name" class="w-100 mt-3">
              <strong> {{ $t("common.File selected") }}:</strong>
              {{ EditForm.attachment.name }}
            </div>
            <div class="mt-4 d-flex justify-content-center">
              <b-button
                variant="primary"
                @click="submit()"
                v-if="
                  $store.state.app.permissions.includes(
                    'store-patientCardTest'
                  ) && !isHistory
                "
                :disabled="EditForm.attachment.length == 0"
              >
                {{ $t("common.submit") }}
              </b-button>
            </div>
          </div>
        </div>
      </div>
    </b-card>
  </div>
</template>

<script>
import {
  BCard,
  BFormGroup,
  BButton,
  BCol,
  BRow,
  BFormInput,
  BTable,
  BDropdown,
  BDropdownItem,
  BPagination,
  BSpinner,
  BFormFile,
  BFormRadio,
  BFormRadioGroup,
  BImg,
} from "bootstrap-vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import VuePhoneNumberInput from "vue-phone-number-input";
import "vue-phone-number-input/dist/vue-phone-number-input.css";
const AutoComplete = () => import("@/components/common/AutoComplete.vue");
import permissionChecker from "@/mixins/permissionChecker";
import vSelect from "vue-select";
import DeleteModal from "@/components/modals/DeleteModal.vue";

export default {
  mixins: [permissionChecker],

  components: {
    BImg,
    BFormRadioGroup,
    BFormFile,
    BCard,
    BFormGroup,
    BButton,
    BCol,
    BRow,
    BFormInput,
    BTable,
    BDropdown,
    BDropdownItem,
    BPagination,
    DeleteModal,
    BSpinner,
    VuePhoneNumberInput,
    AutoComplete,
    vSelect,
    BFormRadio,
  },

  props: ["patientCardId", "isHistory"],
  data() {
    return {
      take: 10,
      options: [
        { item: "LAB", name: this.$t("lab.lab") },
        { item: "RADIOLOGY", name: this.$t("radiology.radiology") },
      ],
      loading: true,
      isNotValid: false,
      dataCount: 0,
      data: [],
      EditForm: {
        patient_card_id: "",
        attachment: [],
        type: "RADIOLOGY",
        _method: "POST",
      },
      createMode: false,
      errorForm: {
        patient_card_id: "",
        tests: [],
      },
      params: {
        form: {},
        path: "",
      },
      file: null,
      currentPage: 1,
      takeOptions: [10, 25, 50, 100],
      searchQuery: "",
      sortBy: "id",
      isSortDirDesc: true,
      page: 1,
      selected: "LAB",
    };
  },
  mounted() {
    this.getAttachments();
  },
  methods: {
    openFileInNewTab(filePath) {
      window.open(filePath, "_blank");
    },
    handleFileUpload() {
      console.log("File uploaded:", this.file);
      // You can process the file here or send it to the server
    },
    deleteDocs(id) {},
    fileName(file) {},

    show(item, mode) {
      if (mode === "create") {
        this.createMode = true;
        this.EditForm = {
          patient_card_id: this.patientCardId,
          tests: [],
          _method: "POST",
        };
      } else {
        this.createMode = false;

        this.EditForm.id = item.id;
        this.EditForm.patient_card_id = this.patientCardId;
        this.EditForm.tests = item.tests;

        this.EditForm._method = "PUT";
      }
      this.$bvModal.show("modal-test-edit");
    },
    showPhoneObj(obj, countryCallingCodeCheck) {
      this.isNotValid = !obj.isValid;
      countryCallingCodeCheck
        ? (this.countryCallingCodeFirst = obj.countryCallingCode)
        : (this.countryCallingCodeSecond = obj.countryCallingCode);
    },
    async getAttachments() {
      this.loading = true;
      // check if there are any null value in the obj we sending

      let url = `/attachment?type=${this.selected}&filter[attachable_id]=${this.patientCardId}`;

      if (this.testFilter) {
        url += `&filter[test_id]=${this.testFilter}`;
      }
      if (this.patientFilter) {
        url += `&filter[patient_card_id]=${this.patientFilter}`;
      }

      await this.getList(url);
      this.dataCount = this.all_data.total;
      this.data = this.all_data.data;
      this.loading = false;
      this.EditForm.attachment = "";
    },
    attachmentChange(e) {
      this.getAttachments();
    },
    deleteModel(item) {
      this.deleteForm = item;
      this.$bvModal.show("modal-attachment-delete");
    },
    deleteItem() {
      this.$store
        .dispatch("delete", `/attachment/${this.deleteForm.id}`)
        .then((response) => {
          this.getAttachments();

          this.$toast({
            component: ToastificationContent,
            position: "top-right",
            props: {
              title: "Delete Success",
              icon: "success",
              variant: "info",
              text: "deleted " + this.deleteForm.first_name + " successfully",
            },
          });
        })
        .catch((error) => {
          this.$toast({
            component: ToastificationContent,
            position: "top-right",
            props: {
              title: "Error",
              variant: "danger",
              text: "Error deleting " + this.deleteForm.first_name,
            },
          });
        });
    },
    submit() {
      this.createMode = true;
      let data = new FormData();
      console.log(this.EditForm.attachment);
      data.append("attachment", this.EditForm.attachment);
      data.append("attachable_type", "patient_card");
      data.append("type", this.selected);
      data.append("_method", "POST");
      data.append("attachable_id", this.patientCardId);

      for (let item in this.errorForm) {
        this.errorForm[item] = "";
        if (this.EditForm[item] == "" || this.EditForm[item] == null)
          delete this.EditForm[item];
      }

      if (this.createMode) {
        (this.params.form = data),
          (this.params.path = `/attachment`),
          this.$store
            .dispatch("create", this.params)
            .then((response) => {
              this.getAttachments();
            })
            .catch((error) => {
              if (error.response.status === 400) {
                for (let item in error.response.data) {
                  this.$toast({
                    component: ToastificationContent,
                    position: "top-right",
                    props: {
                      title: "validation error",
                      variant: "danger",
                      text: error.response.data[item][0],
                    },
                  });
                }
              }
            });
      }
    },
  },
};
</script>
<style scoped>
/* CSS */
.button-preview {
  align-items: center;
  appearance: none;
  background-color: #fff;
  border: 1px solid #dbdbdb;
  border-radius: 0.375em;
  box-shadow: none;
  box-sizing: border-box;
  color: #363636;
  cursor: pointer;
  display: inline-flex;
  font-family: BlinkMacSystemFont, -apple-system, "Segoe UI", Roboto, Oxygen,
    Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", Helvetica,
    Arial, sans-serif;
  font-size: 1rem;
  height: 2.5em;
  justify-content: center;
  line-height: 1.5;
  padding: calc(0.5em - 1px) 1em;
  position: relative;
  text-align: center;
  user-select: none;
  -webkit-user-select: none;
  touch-action: manipulation;
  vertical-align: top;
  white-space: nowrap;
  margin-bottom: 3px;
  margin-right: 10px;
}

.button-preview:active {
  border-color: #4a4a4a;
  outline: 0;
}

.button-preview:focus {
  border-color: #485fc7;
  outline: 0;
}

.button-preview:hover {
  border-color: #b5b5b5;
  background: rgb(245, 241, 241);
}

.button-preview:focus:not(:active) {
  box-shadow: rgba(72, 95, 199, 0.25) 0 0 0 0.125em;
}

.modify {
  height: 6rem;
  font-size: 2rem;
  align-items: center;
}

.modify:hover {
  box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
}
</style>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
